export default __webpack_public_path__ + "static/media/1803_bar.aaeae19f.jpg";